import ChecklistStatusPage from '@components/ChecklistStatusPage/ChecklistStatusPage';

const ChecklistStatus = () => {
  return (
    <>
      <ChecklistStatusPage />
    </>
  );
};

export default ChecklistStatus;
